import config from '../config';

const API_BASE_URL = config.API_URL_PATH;

// Общая функция для выполнения HTTP запросов
const apiRequest = async (endpoint, options = {}) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
      ...options.headers,
    };
    
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      headers,
      ...options,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.payload; // API возвращает данные в поле payload
  } catch (error) {
    console.error('API request failed:', error);
    throw error;
  }
};

// API для enum'ов
export const enumsApi = {
  // Поиск типов платформ с фильтрацией
  searchPlatformTypes: async (searchParams = {}) => {
    const params = new URLSearchParams();
    
    // Добавляем параметры поиска
    if (searchParams.searchQuery) {
      params.append('searchQuery', searchParams.searchQuery);
    }
    
    return apiRequest(`/enums/platform-types/search?${params.toString()}`);
  },
};

// API для городов (платформ)
export const citiesApi = {
  // Получить все города/платформы
  getAll: async () => {
    return apiRequest('/cities/get-by-filter?objectsCount=1000');
  },
  
  // Поиск городов с фильтрацией и пагинацией
  search: async (searchParams = {}) => {
    const params = new URLSearchParams();
    
    // Добавляем параметры поиска
    if (searchParams.searchQuery) {
      params.append('searchQuery', searchParams.searchQuery);
    }
    
    // Добавляем параметры пагинации
    if (searchParams.page !== undefined) {
      params.append('page', searchParams.page);
    }
    if (searchParams.objectsCount !== undefined) {
      params.append('objectsCount', searchParams.objectsCount);
    }

    params.append('SortField', "Name");
    
    params.append('SortOrder', "0");
    
    return apiRequest(`/cities/get-by-filter?${params.toString()}`);
  },
};

// API для специальностей
export const specialisationsApi = {
  // Получить все специальности
  getAll: async () => {
    return apiRequest('/specialisations/get-by-filter?objectsCount=1000');
  },
  
  // Поиск специальностей с фильтрацией и пагинацией
  search: async (searchParams = {}) => {
    const params = new URLSearchParams();
    
    // Добавляем параметры поиска
    if (searchParams.searchQuery) {
      params.append('searchQuery', searchParams.searchQuery);
    }
    
    // Добавляем параметры пагинации
    if (searchParams.page !== undefined) {
      params.append('page', searchParams.page);
    }
    if (searchParams.objectsCount !== undefined) {
      params.append('objectsCount', searchParams.objectsCount);
    }

    params.append('SortField', "Name");
    
    params.append('SortOrder', "0");
    
    return apiRequest(`/specialisations/get-by-filter?${params.toString()}`);
  },
};

// API для докторов
export const doctorsApi = {
  // Получить докторов с фильтрацией и пагинацией
  getByFilter: async (searchParams = {}) => {
    // Все параметры сериализуем в query string и отправляем GET-запросом
    let url = '/doctors/get-by-filter';
    const params = new URLSearchParams();
    // Гарантируем, что includeCities, includeSpecialisations, includeRates всегда true
    const convertParams = {
      ...(searchParams.convertParams || {}),
      includeCities: 'true',
      includeSpecialisations: 'true',
      includeRates: 'true',
    };
    Object.entries(convertParams).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.append(key, value);
      }
    });
    // Остальные параметры
    const { convertParams: _cp, ...rest } = searchParams;
    Object.entries(rest).forEach(([key, value]) => {
      if (key === 'platformRatingFilters' && Array.isArray(value)) {
        value.forEach((f, i) => {
          if (f.PlatformType !== undefined) params.append(`platformRatingFilters[${i}].PlatformType`, f.PlatformType);
          if (f.From !== undefined) params.append(`platformRatingFilters[${i}].From`, f.From);
          if (f.To !== undefined) params.append(`platformRatingFilters[${i}].To`, f.To);
        });
      } else if (Array.isArray(value)) {
        value.forEach(v => params.append(key, v));
      } else if (value !== undefined && value !== null && value !== '') {
        params.append(key, value);
      }
    });
    url += `?${params.toString()}`;
    return apiRequest(url);
  },
}; 